import {
    CLEAR_EVENTS, INIT_MATOMO, PREPARE_EVENT, PUSH_EVENT
} from './Matomo.action';
/** @namespace Bodymod/Matomo/Store/Matomo/Reducer/getInitialState */
export const getInitialState = () => ({
    matomo: {},
    events: [],
    isMatomoInitialized: false
});

/** @namespace Bodymod/Matomo/Store/Matomo/Reducer/MatomoReducer */
export const MatomoReducer = (state = getInitialState(), action) => {
    const { events } = state;
    switch (action.type) {
    case INIT_MATOMO:
        const { matomo } = action;

        return {
            ...state,
            matomo,
            isMatomoInitialized: true
        };
    case PREPARE_EVENT:
        return state;
    case PUSH_EVENT:
        const { event, data } = action;
        return {
            ...state,
            events: [...events, { event, data }]
        };
    case CLEAR_EVENTS:
        const { eventsToClear } = action;
        return {
            ...state,
            events: events.filter((event) => !eventsToClear.some((evt) => evt.event === event.event))
        };
    default:
        return state;
    }
};

export default MatomoReducer;
